<template>
  <div class="row mt-4">
    <div class="col-12 subsform--submitting" v-if="submitting">
      <Loader />
    </div>
    <div class="col-12 typography subsform">
      <div class="container typography">
        <div class="row row--primary mt-4">
          <div class="col-12">
            <h1>Manage Subscriptions for {{ email }}</h1>
            <h2 class="mt-4" v-if="!success">Receive email updates when new forecasts are posted for:</h2>
          </div>
        </div>

        <div class="row mb-4" v-if="!success">
          <div class="col-xs-12 col-md-4" v-for="column in 3">
            <div v-for="region in regionColumn(column)" class="custom-control custom-checkbox">
              <input
                type="checkbox"
                :id="'region_' + region.id"
                :value="region.id"
                class="custom-control-input"
                :checked="subscriptions.includes(region.id)"
                v-model="subscriptions"
              />
              <label :for="'region_' + region.id" class="custom-control-label">{{ region.title }}</label>
            </div>
          </div>
        </div>

        <div class="row subsform__steps" v-if="!success">
          <div class="col-12 text-center">
            <button
              class="button button--next button--dark-with-light-outline"
              :disabled="submitting"
              @click="submit()"
            >
              Update subscriptions
            </button>
          </div>
          <div class="col-12 text-center">
            <button
              class="button button--link button--dark-with-light-outline"
              :disabled="submitting"
              @click="unsubscribeAll()"
            >
              Unsubscribe from all
            </button>
          </div>
        </div>

        <div class="row row--primary subsform__steps" v-if="success">
          <div class="col-12 text-left">
            <h2 class="mb-4">Your subscriptions have been updated.</h2>
            <button class="button button--back button--dark-with-light-outline mb-5" @click="success = false">
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/loader/Loader";
import API from "../api/API";
import { mapState } from "vuex";

export default {
  components: {
    Loader
  },

  data() {
    return {
      email: "",
      submitting: true,
      subscriptions: [],
      success: false
    };
  },

  computed: {
    ...mapState({
      cms: state => state.cms,
      regions: state => state.regions.filter(region => region.geometry !== null)
    })
  },

  methods: {
    regionColumn(column) {
      let regionsPerColumn = Math.ceil(this.regions.length / 3);

      let start = (column - 1) * regionsPerColumn;
      let end = start + regionsPerColumn;

      return this.regions.slice(start, end);
    },

    submit() {
      this.submitting = true;

      API.submit("subscription", { subscriptions: this.subscriptions }, this.key).then(response => {
        this.subscriptions = response.data.subscriptions;
        this.success = true;
        this.submitting = false;
      });
    },

    unsubscribeAll() {
      this.subscriptions = [];
      this.submit();
    }
  },

  created() {
    this.key = this.$route.params.key;

    API.fetch("subscription", this.key).then(response => {
      this.submitting = false;
      this.subscriptions = response.data.subscriptions;
      this.email = response.data.email;
    });
  }
};
</script>
